import React from 'react';
import {Flex, Button} from 'components';
import {Modal, pluralize, redirect, useParams, useSearchParams, useSelector} from 'helpers';
import {goals, session, units} from 'store';
import {AnyObject} from 'types';

export const TemplateModal: Modal<{id: string} & ReturnType<ReturnType<typeof goals.findTemplate>>> = ({id, popup, activities, milestones, template}) => {
  const {premium} = useSelector(session.subscription);
  const params: AnyObject = {
    ...useParams(),
    ...useSearchParams(),
  };
  const createOwn = () => {
    redirect(`../milestones/?redirect=${encodeURIComponent(params.redirect ?? '')}`);
    popup.close();
  };
  const usePlan = () => {
    redirect('../');
    popup.close();
    if (premium) {
      goals.dispatch.upsert({id, note: template.note});
      goals.dispatch.duplicate({id, activities, milestones, duplicateId: id});
    } else {
      session.forbid();
    }
  };
  return (
    <>
      <h4>Goal Plan</h4>
      <p>
        Do you want to use our predefined plan for this goal,
        including {pluralize('milestone', milestones.length, true)} and {pluralize('activity', activities.length, true)}?
      </p>
      <Flex className={['spacing', 'right']}>
        <Button onClick={createOwn} className="subtle">No, I will create my own plan</Button>
        <Button onClick={usePlan} className="primary">Yes, Use Predefined Plan</Button>
      </Flex>
    </>
  );
};
